import _ from 'lodash';
import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import styles from './SoundWave.module.scss';
import classNames from 'classnames';

export default function SoundWave({
    className,
    dataProvider,
    strokeWidth = 8,
    stroke,
    opacity,
    withGain,
}) {
    const [path, setPath] = useState(getDefaultPath());

    useEffect(() => {
        const listener = dataArray => setPath(formPathFromRawData(dataArray, withGain));
        dataProvider.on('data', listener);
        return () => dataProvider.removeListener('data', listener);
    }, []);

    const svgClassName = classNames(styles.wave, className);

    return (
        <svg
            className={svgClassName}
            width='2000'
            height='2000'
            viewBox='-1000 -1000 2000 2000'
            preserveAspectRatio='none'
        >
            <path
                vectorEffect='non-scaling-stroke'
                stroke={stroke}
                strokeWidth={strokeWidth}
                fill='transparent'
                opacity={opacity}
                d={path}
            />
        </svg>
    );
}

function getDefaultPath() {
    return 'M-1000 0 L1000 0';
}

function formPathFromRawData(dataArray, withGain) {
    const width = 1000;
    const height = 1000;

    const dx = (2 * width) / (1 + dataArray.length);

    const path = [`M${-width} 0`];

    for (let i = 1; i <= dataArray.length; i++) {
        const x = -width + i * dx;
        const yNorm = (dataArray[i] - 128) / 128;
        const yAbs = Math.abs(yNorm);
        const ySign = Math.sign(yNorm);
        const y = ySign * kernel(x, width) * scaleY(yAbs, withGain) * height;
        path.push(`L${x || 0} ${y || 0}`);
    }

    path.push(`L${width} 0`);
    return path.join(' ');
}

function kernel(x, width) {
    const z = (2 * x) / width;
    return Math.exp(-z * z);
}

function scaleY(a, withGain) {
    if (!withGain) {
        return a;
    }

    return Math.pow(a, 1 / 2);
}
